import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import VuePaginate from "vue-paginate";
Vue.use(VuePaginate);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
  },
    {
    path: "Calendar",
    name: "Calendar",
    component: () => import(/* webpackChunkName: "home" */ "../views/Calendar.vue"),
  },
    {
    path: "/ras",
    name: "ras",
    component: () => import(/* webpackChunkName: "home" */ "../views/ras.vue"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      authRequired: true,
      //onboardingCompleteRequired: true,
    },
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
  },
  {
    path: "/admin-add-sermon",
    name: "addsermon",
    meta: {
      authRequired: true,
      onboardingCompleteRequired: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "adminaddemployee" */ "../views/AddSermon.vue"
      ),
  },
   {
    path: "/admin-add-member",
    name: "adminaddmember",
    meta: {
      authRequired: true,
      onboardingCompleteRequired: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "adminaddemployee" */ "../views/AdminAddMember.vue"
      ),
  },
     {
    path: "/admin-add-visitor",
    name: "adminaddvisitor",
    meta: {
      authRequired: true,
      onboardingCompleteRequired: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "adminaddemployee" */ "../views/AdminAddVisitor.vue"
      ),
  },
    {
    path: "/admin-sermon-view/:id",
    name: "adminsermonview",
    meta: {
      authRequired: true,
      onboardingCompleteRequired: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "adminaddemployee" */ "../views/AdminSermonView.vue"
      ),
  },
      {
    path: "/admin-member-view/:id",
    name: "adminmemberview",
    meta: {
      authRequired: true,
      onboardingCompleteRequired: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "adminaddemployee" */ "../views/AdminMemberView.vue"
      ),
  },
        {
    path: "/admin-visitor-view/:id",
    name: "adminvisitorview",
    meta: {
      authRequired: true,
      onboardingCompleteRequired: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "adminaddemployee" */ "../views/AdminVisitorView.vue"
      ),
  },
  
  {
    path: "/GraceAuth",
    name: "userlogin",
    component: () => import(/* webpackChunkName: "auth" */ "../views/UserLogin.vue"),
  },


  // {
  //   path: "/demo",
  //   name: "demo",
  //   meta: {
  //     authRequired: false,
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "adminexaminerview" */ "../views/AdminExaminerView.vue"
  //     ),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.name !== "auth" &&
    to.meta.authRequired &&
    !router.$store.getters["isLoggedIn"] &&
    !router.$auth.currentUser
  ) {
    return next({ name: "auth", query: { from: to.path } });
  }

  if (
    to.name !== "dashboard" &&
    to.meta.onboardingCompleteRequired &&
    !router.$store.getters["isOnboarded"]
  ) {
    return next({ name: "dashboard" });
  }

  if (
    to.name === "dashboard" &&
    to.meta.onboardingCompleteRequired &&
    router.$store.getters["dashboard"]
  ) {
    return next({ name: "dashboard" });
  }

  return next();
});

export default router;
